import { combineReducers } from '@reduxjs/toolkit'
import { userReducer } from './slice/userSlice'
import { orderReducer } from './slice/orderSlice';

const rootReducer = combineReducers({
  userReducer,
  orderReducer,
})

export default rootReducer;